var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-picker"},[_c('date-picker',{attrs:{"type":"time","confirm":_vm.confirm,"clearable":_vm.clearable,"editable":_vm.editable,"confirm-text":_vm.confirmText,"placeholder":_vm.placeholder,"value":_vm.value,"format":"HH:mm"},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }